<template>
  <div>
    <div @click="showToggle()" class="header-button header-favourite">
      <svg class="svg-sprite-icon svg-sprite-unstyled icon-hearth">
        <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-hearth"></use>
      </svg>
      <span class="header-favourite--count">{{count}}</span>


    </div>
    <div v-if="show" class="wishlist">
      <div class="wishlist--header">
        <svg @click="show = false" class="svg-sprite-icon svg-sprite-unstyled icon-close">
          <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-close"></use>
        </svg>
        <div class="wishlist--title heading-border">
          Your wish list
        </div>
        <div class="wishlist-count">
          you have <span>{{count}} items</span>
        </div>
      </div>
      <!-- <div class="wishlist--shipping">
        <svg class="svg-sprite-icon svg-sprite-unstyled icon-shipping">
          <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-shipping"></use>
        </svg>
        By one more and Get
        <nuxt-link to="#">free shipping</nuxt-link>
      </div> -->
      <div class="wishlist--products">
        <div class="wishlist--product" v-for="(product, index) in products" v-bind:key="index">
          <div class="wishlist--product-image">
            <img :src="'/upload/' + product.image" alt="">
          </div>
          <div class="wishlist--product-info">
            <div class="wishlist--product-title">
              {{product.title|str_limit(20)}}
            </div>
            <div class="wishlist--product-chars">
              <span class="wishlist--product-key">Format:</span>
              <span class="wishlist--product-val" v-html="product.format"></span>
            </div>
            <div class="wishlist--product-qty">
              <div class="cs-qty">
                <input class="cs-qty--field" :value="favorites_storage_products[product.id]" type="text">
                <div class="cs-qty--minus" @click="updateQty(product, -1)">-</div>
                <div class="cs-qty--plus" @click="updateQty(product, 1)">+</div>
              </div>
            </div>
          </div>
          <svg class="svg-sprite-icon svg-sprite-unstyled icon-close" @click="deleteFromFavorites(product)">
            <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-close"></use>
          </svg>
        </div>
      </div>
      <div class="wishlist--footer">
        <div @click="modal = true" class="btn btn--wishlist">
          Make a Request
          <svg @click="show = false" class="svg-sprite-icon svg-sprite-unstyled icon-arrow-right-long">
            <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-arrow-right-long"></use>
          </svg>
        </div>
      </div>
    </div>


    <div v-if="modal" class="modal modal-request">
      <div class="modal-content">
        <div class="modal-close">
          <svg @click="modal = false" class="svg-sprite-icon svg-sprite-unstyled icon-close">
            <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-close"></use>
          </svg>
        </div>


        <div class="modal-title heading-border">Make a Request</div>
        <div class="modal-request--info">
          <div class="modal-request--text">
            Our professional team will assist you from the moment you place the order till the moment you receive it.
          </div>
          <div class="modal-request--note">
            PLEASE NOTE: We sell to the certified doctors and companies only.
          </div>
        </div>
        <form class="contact--form" @submit.prevent="submit" enctype="multipart/form-data">
            <div class="contact--form-row">
                <div class="contact--form-col">
                    <label label="name" class="input-block">
                        <span class="input-block--label"></span>
                        <input v-model="Form.name"  type="text" id="name" placeholder="Name" maxlength="255" required="required">
                        <span class="error-message">{{ error.name }}</span>
                    </label>
                    <label label="state" class="input-block">
                        <span class="input-block--label">State</span>
                        <select v-model="Form.state" label="State" type="select" id="state">
                            <option selected="" v-for="state in states" v-bind:value="state.id" :key="state.id">
                                {{ state.name }}
                            </option>
                        </select>
                        <span class="error-message">{{ error.state }}</span>
                    </label>
                </div>
                <div class="contact--form-col">
                    <label label="email" class="input-block">
                        <span class="input-block--label"></span>
                        <input v-model="Form.email" type="email" id="email" placeholder="Email" maxlength="255" required="required">
                        <span class="error-message">{{ error.email }}</span>
                    </label>
                    <label label="phone" class="input-block">
                        <span class="input-block--label"></span>
                        <input v-model="Form.phone" type="text" id="phone" placeholder="Phone Number" maxlength="255" required="required">
                        <span class="error-message">{{ error.phone }}</span>
                    </label>
                </div>
            </div>
            <div class="contact--form-bottom">
                <button type="submit" class="btn btn-arrow btn-default contact--form-submit" :disabled="loading">
                    Send
                    <svg class="svg-sprite-icon svg-sprite-unstyled icon-arrow-right-long">
                      <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-arrow-right-long"></use>
                    </svg>
                </button>
                <template v-if="success">
                    <br>
                    <br>
                    <div class="contact--note">Successfully Sent</div>
                </template>
            </div>
        </form>
      </div>
    </div>
  </div>

</template>

<script>
export default {
    props: {
        urlProducts: {
            type: String,
            required: false
        },
        requestUrl: {
            type: String
        },
        StatesUrl: {
            type: String
        }
    },
    data: () => ({
        show: false,
        modal: false,
        products: [],
        states: [],
        Form: {
            name: '',
            email: '',
            state: '',
            phone: ''
        },
        error: {
            
        },
        loading: false,
        success: false,
        count: 0,
        products: [],
        favorites_products: [],
        favorites_storage_products: null
    }),
    methods: {
        fetch() {
            this.loading = true;
            if(this.favorites_products.length) {
              axios.get(this.urlProducts, {
                params: {
                    page: 1,
                    products: this.favorites_products
                }
              }).then((res) => {
                this.products = res.data.data
                this.loading = false;
              });
            }
            axios.get(this.StatesUrl).then((res) => {
                this.states = res.data;
            });
        },
        favouriteCount() {
          setInterval(() => {
              if(localStorage.getItem("products") !== null) {
                let products = JSON.parse(localStorage.getItem("products"));
                this.count = Object.keys(products).length;
            };
          }, 2000);
        },
        getFavorites() {
            let products = JSON.parse(localStorage.getItem("products"));
            let favorites_storage = Object.assign({}, products);
            let favorites_keys = Object.keys(favorites_storage);
            let res = favorites_keys.map(function(item) {
                return parseInt(item);
            });
            this.favorites_storage_products = favorites_storage;
            this.favorites_products = res;
        },
        showToggle() {
            this.getFavorites();
            this.fetch();
            this.show = !this.show
        },
        updateQty(product, value) {
            let products = JSON.parse(localStorage.getItem("products"));
            products[product.id] += value;
            if(products[product.id] < 1) {
                products[product.id] = 1;
            }
            localStorage.setItem("products", JSON.stringify(products));
            this.getFavorites();
        },
        deleteFromFavorites(product) {
            let products = JSON.parse(localStorage.getItem("products"));
            delete products[product.id];
            localStorage.setItem("products", JSON.stringify(products));
            this.getFavorites();
            this.fetch();
        },
        submit() {
            this.loading = true;
            let formData = this.Form;
            this.Form['products'] = JSON.parse(localStorage.getItem("products"));
            axios.post(this.requestUrl, formData)
            .then((res) => {
                this.error = '';
                if(res.data.Errors) {
                    this.error = res.data.Errors;
                    var errors = res.data.Errors;
                    var errormessage = '';
                    Object.keys(errors).forEach(function(key) {
                        errormessage += errors[key] + '<br />';
                    });
                    console.log(errormessage);
                    this.loading = false;
                }
                // let data = res.data;
                // this.notify('Sended', 2000, 'success');
                if(res.data.success) {
                    this.loading = false;
                    this.success = true;
                    localStorage.removeItem('products');
                    this.products = [];
                    this.getFavorites();
                    this.count = 0;
                }
                this.loading = false;
                // this.isModalVisible = false;
            }).catch(err => {
                this.loading = false;
                console.log(err.message);
            });
        },
    },
    mounted() {
        this.favouriteCount();
    },
}
</script>